// src/utils/feriePermessi.js
// Richieste di ferie e permessi (ottobre 2026): il permesso si chiede a giornata intera
// (dal … al …) oppure A ORE (un giorno, dalle … alle …). Regole e testi in un posto solo,
// usati dalla richiesta (RichiestaFeriePage) e dall'approvazione (ApprovazioneFeriePermessiPage).
import { minutiDaOra } from "./segmentiGiornata";

const fmtData = (s) => { if (!s) return ""; const [y, m, g] = s.split("-"); return `${g}/${m}/${y}`; };

/** «2 h», «1 h 30 min», «45 min» */
export function testoDurata(minuti) {
  const m = Math.max(0, Math.round(Number(minuti) || 0));
  const h = Math.floor(m / 60), r = m % 60;
  if (!h) return `${r} min`;
  return r ? `${h} h ${r} min` : `${h} h`;
}

/** Minuti tra due orari «HH:MM» (0 se non validi o al contrario). */
export function minutiTra(dalle, alle) {
  const a = minutiDaOra(dalle), b = minutiDaOra(alle);
  return a != null && b != null && b > a ? b - a : 0;
}

/**
 * Controlli sulla richiesta prima di inviarla. Restituisce un messaggio o null.
 * oreGiornata = ore lavorative standard dell'azienda (Impostazioni aziendali).
 */
export function validaRichiesta({ tipo, aOre, dataInizio, dataFine, oraInizio, oraFine }, oreGiornata = 8) {
  if (aOre && tipo === "permesso") {
    if (!dataInizio) return "Indica il giorno del permesso";
    if (!oraInizio || !oraFine) return "Indica dalle che ora alle che ora";
    const min = minutiTra(oraInizio, oraFine);
    if (!min) return "L'ora di fine deve essere dopo l'ora di inizio";
    if (min > (Number(oreGiornata) || 8) * 60) return `Il permesso supera la giornata lavorativa (${testoDurata((Number(oreGiornata) || 8) * 60)}): scegli «Giornata intera»`;
    return null;
  }
  if (!dataInizio || !dataFine) return "Indica le date di inizio e fine";
  if (dataFine < dataInizio) return "La data di fine non può essere prima di quella di inizio";
  return null;
}

/** «Ferie — 20/10/2026 → 24/10/2026» · «Permesso — 20/10/2026, dalle 10:00 alle 12:00 (2 h)» */
export function descriviRichiesta(r) {
  const nome = r.tipo === "ferie" ? "Ferie" : "Permesso";
  if (r.aOre) return `${nome} — ${fmtData(r.dataInizio)}, dalle ${r.oraInizio} alle ${r.oraFine} (${testoDurata(minutiTra(r.oraInizio, r.oraFine))})`;
  return `${nome} — ${fmtData(r.dataInizio)}${r.dataInizio !== r.dataFine ? ` → ${fmtData(r.dataFine)}` : ""}`;
}
